import React, { Suspense } from 'react';
import { importFromS3 } from '../../utils/importFromS3';
import { SpinnerLoading } from '../../components/SpinnerLoading/SpinnerLoading';

const AuthPlugin = React.lazy(() => importFromS3('tcc-auth-plugin'));

export const AuthPluginContainer = () => (
  <Suspense fallback={<SpinnerLoading />}>
    <AuthPlugin />
  </Suspense>
);
